import { render, staticRenderFns } from "./updateTypeDialog.vue?vue&type=template&id=6b565ffc"
import script from "./updateTypeDialog.vue?vue&type=script&lang=js"
export * from "./updateTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports